export default "__VITE_ASSET__GAYZ4SCR__"